(function () {
  "use strict";

  // ===== Scroll reveal (replaces framer-motion whileInView) =====
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    // fail-safe: never leave content invisible-but-space-taking
    setTimeout(function () { els.forEach(function (el) { el.classList.add("revealed"); }); }, 1200);
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("revealed"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("revealed");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.01, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  // ===== Countdown (replaces Countdown.tsx) =====
  function pad(n) { return String(n).padStart(2, "0"); }
  function initCountdowns() {
    var nodes = document.querySelectorAll("[data-countdown]");
    if (!nodes.length) return;
    function tick() {
      var now = Date.now();
      nodes.forEach(function (node) {
        var target = new Date(node.getAttribute("data-countdown")).getTime();
        var wrap = node.closest ? node.closest("[data-countdown-wrap]") : null;
        if (!target || target - now <= 0) {
          node.classList.add("is-expired");
          if (wrap) wrap.classList.add("is-expired");
          return;
        }
        node.classList.remove("is-expired");
        if (wrap) wrap.classList.remove("is-expired");
        var total = target - now;
        var d = Math.floor(total / 86400000);
        var h = Math.floor((total % 86400000) / 3600000);
        var m = Math.floor((total % 3600000) / 60000);
        var s = Math.floor((total % 60000) / 1000);
        if (node.classList.contains("countdown")) {
          node.innerHTML =
            unit(d, "Days") + unit(h, "Hrs") + unit(m, "Min") + unit(s, "Sec");
        } else {
          node.textContent = d + "d " + pad(h) + "h " + pad(m) + "m " + pad(s) + "s";
        }
      });
    }
    function unit(v, label) {
      return '<div class="unit"><span class="val">' + pad(v) +
        '</span><span class="lbl">' + label + "</span></div>";
    }
    tick();
    setInterval(tick, 1000);
  }

  // ===== Navbar scroll state =====
  function initNavbar() {
    var nav = document.querySelector("[data-navbar]");
    if (!nav) return;
    function onScroll() {
      if (window.scrollY > 40) nav.classList.add("scrolled");
      else nav.classList.remove("scrolled");
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  // ===== Mobile menu =====
  function initMobileMenu() {
    var toggle = document.querySelector("[data-menu-toggle]");
    var menu = document.querySelector("[data-mobile-menu]");
    if (!toggle || !menu) return;
    toggle.addEventListener("click", function () {
      var open = menu.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        menu.classList.remove("open");
        toggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  // ===== Sticky CTA (show after hero scrolls past) =====
  function initStickyCta() {
    var bar = document.querySelector("[data-sticky-cta]");
    if (!bar) return;
    function onScroll() {
      if (window.scrollY > 250) bar.classList.add("visible");
      else bar.classList.remove("visible");
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  // ===== Click-to-play video (replaces ViralVideos play state) =====
  function initVideos() {
    document.querySelectorAll("[data-play-video]").forEach(function (wrap) {
      var video = wrap.querySelector("video");
      var overlay = wrap.querySelector("[data-play-overlay]");
      if (!video) return;
      function toggle() {
        if (video.paused) { video.play(); wrap.classList.add("playing"); }
        else { video.pause(); wrap.classList.remove("playing"); }
      }
      video.addEventListener("click", toggle);
      if (overlay) overlay.addEventListener("click", toggle);
      video.addEventListener("play", function () { wrap.classList.add("playing"); });
      video.addEventListener("pause", function () { wrap.classList.remove("playing"); });
    });
  }

  function init() {
    initReveal();
    initCountdowns();
    initNavbar();
    initMobileMenu();
    initStickyCta();
    initVideos();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// ===== Hero slideshow =====
(function () {
  function initSliders() {
    document.querySelectorAll("[data-slider]").forEach(function (root) {
      if (root.dataset.sliderInit) return; root.dataset.sliderInit = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll(".qc-slide"));
      if (slides.length < 2) return;
      var dotsWrap = root.querySelector("[data-dots]");
      var i = 0, timer = null;
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      var dots = slides.map(function (_, n) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "qc-dot"; b.setAttribute("role", "tab");
        b.setAttribute("aria-label", "Photo " + (n + 1));
        b.addEventListener("click", function () { go(n); restart(); });
        if (dotsWrap) dotsWrap.appendChild(b);
        return b;
      });

      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle("is-active", k === i); });
        dots.forEach(function (d, k) { d.setAttribute("aria-selected", k === i ? "true" : "false"); });
      }
      function next() { go(i + 1); }
      function prev() { go(i - 1); }
      function start() { stop(); if (!reduce) timer = setInterval(next, 4500); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }

      var p = root.querySelector("[data-prev]"), n2 = root.querySelector("[data-next]");
      if (p) p.addEventListener("click", function () { prev(); restart(); });
      if (n2) n2.addEventListener("click", function () { next(); restart(); });
      root.addEventListener("mouseenter", stop);
      root.addEventListener("mouseleave", start);

      var x0 = null;
      root.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      root.addEventListener("touchend", function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
        x0 = null; start();
      }, { passive: true });

      document.addEventListener("visibilitychange", function () { document.hidden ? stop() : start(); });
      go(0); start();
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initSliders);
  else initSliders();
})();

// ===== Buy CTAs open the cart drawer =====
(function(){
  var CAM = window.QC_CAM_VARIANT, EC = window.QC_EC || null;
  var overlay = document.querySelector('[data-drawer-overlay]');
  var drawer  = document.querySelector('[data-drawer]');
  if(!drawer) return;
  var body = drawer.querySelector('[data-drawer-body]');
  var foot = drawer.querySelector('[data-drawer-foot]');
  var subtotalEl = drawer.querySelector('[data-drawer-subtotal]');
  var saveEl = drawer.querySelector('[data-drawer-save]');

  function money(cents){ return '$' + (cents/100).toFixed(2); }
  function open(){ drawer.hidden=false; overlay.hidden=false; document.body.style.overflow='hidden';
    requestAnimationFrame(function(){ drawer.classList.add('is-open'); }); }
  function close(){ drawer.classList.remove('is-open'); overlay.hidden=true; document.body.style.overflow='';
    setTimeout(function(){ drawer.hidden=true; }, 280); }
  function busy(b){ drawer.classList.toggle('is-busy', b); }

  function render(cart){
    body.innerHTML='';
    if(!cart.items.length){ body.innerHTML='<p class="qc-drawer-empty">Your cart is empty.</p>'; foot.hidden=true; return; }
    var hasEC=false, savings=0;
    cart.items.forEach(function(it, idx){
      if(EC && it.variant_id===EC.id) hasEC=true;
      savings += (it.original_line_price - it.final_line_price);
      var isEC = EC && it.variant_id===EC.id;
      var row=document.createElement('div'); row.className='qc-di';
      row.innerHTML =
        (it.image?'<img src="'+it.image+'" alt="">':'') +
        '<div class="qc-di-main">'+
          '<div class="qc-di-title">'+it.product_title+'</div>'+
          '<div class="qc-di-price">'+money(it.final_price)+(it.quantity>1?' each':'')+'</div>'+
          (isEC?'' :
            '<div class="qc-di-qty" data-line="'+(idx+1)+'">'+
              '<button type="button" data-step="-1" aria-label="Decrease">&minus;</button>'+
              '<span>'+it.quantity+'</span>'+
              '<button type="button" data-step="1" aria-label="Increase">+</button>'+
            '</div>')+
          '<button type="button" class="qc-di-remove" data-remove="'+(idx+1)+'">Remove</button>'+
        '</div>'+
        '<div class="qc-di-line">'+
          (it.original_line_price > it.final_line_price
            ? '<span class="qc-di-was">'+money(it.original_line_price)+'</span><br>'
            : '')+
          money(it.final_line_price)+'</div>';
      body.appendChild(row);
    });
    if(EC && !hasEC){
      var offer=document.createElement('div'); offer.className='qc-ec-offer';
      offer.innerHTML='<p>&#128737;&#65039; Add 2-Year Extended Coverage</p>'+
        '<small>24 months of coverage against defects in materials and workmanship. '+money(EC.price)+'</small>'+
        '<button type="button" class="qc-ec-add" data-ec-add>Add coverage</button>';
      body.appendChild(offer);
    }
    var orig = cart.items.reduce(function(a,i){ return a + i.original_line_price; }, 0);
    if(orig > cart.total_price){
      subtotalEl.innerHTML = '<span class="qc-di-was">'+money(orig)+'</span> '+money(cart.total_price);
    } else {
      subtotalEl.textContent = money(cart.total_price);
    }
    if(savings>0){ saveEl.hidden=false; saveEl.textContent='You save '+money(savings); } else saveEl.hidden=true;
    foot.hidden=false;
    wire();
  }
  function refresh(){ busy(true); return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ render(c); busy(false); return c; }); }
  function change(line, qty){ busy(true);
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json();}).then(function(c){ render(c); busy(false); }); }
  function addEC(){ if(!EC) return; busy(true);
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:EC.id,quantity:1}]})})
      .then(function(){ refresh(); }); }
  function wire(){
    body.querySelectorAll('.qc-di-qty').forEach(function(q){
      var line=parseInt(q.getAttribute('data-line'),10);
      var cur=parseInt(q.querySelector('span').textContent,10);
      q.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){ change(line, Math.max(0, cur+parseInt(b.getAttribute('data-step'),10))); });
      });
    });
    body.querySelectorAll('[data-remove]').forEach(function(b){
      b.addEventListener('click', function(){ change(parseInt(b.getAttribute('data-remove'),10), 0); });
    });
    var ec=body.querySelector('[data-ec-add]'); if(ec) ec.addEventListener('click', addEC);
  }

  function isBuy(a){ if(!a) return false; if(a.hasAttribute('data-buy')) return true;
    var href=a.getAttribute('href')||''; return href.indexOf('#preorder')!==-1; }
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-drawer-close]')||e.target.closest('[data-drawer-overlay]')){ close(); return; }
    var a=e.target.closest('a[href], [data-buy]');
    if(!isBuy(a)) return;
    if(!CAM) return;
    e.preventDefault();
    open(); busy(true);
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:CAM,quantity:1}]})})
      .then(function(){ refresh(); }).catch(function(){ window.location.href='/cart'; });
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !drawer.hidden) close(); });
})();
